export default {"src":"/_next/static/media/logo-footer-w.3f255052.svg","height":72,"width":128,"blurWidth":0,"blurHeight":0};